// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"RegistrationAndOrderGuard_spinnerContainer__B0e3C"};